import { Component, Input } from '@angular/core';

@Component({
    selector: 'finder-aag-duration',
    templateUrl: './aag-duration.component.html',
    styleUrls: ['./aag-duration.component.scss'],
})
export class AagDurationComponent {

    @Input() icon: string;
    @Input() label: string;
    @Input() alt: string;
    @Input() time: string;

}
